import { render, staticRenderFns } from "./VideoCalls.vue?vue&type=template&id=5d4b0540&scoped=true"
import script from "./VideoCalls.vue?vue&type=script&lang=js"
export * from "./VideoCalls.vue?vue&type=script&lang=js"
import style0 from "./VideoCalls.vue?vue&type=style&index=0&id=5d4b0540&prod&lang=scss"
import style1 from "./VideoCalls.vue?vue&type=style&index=1&id=5d4b0540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b0540",
  null
  
)

export default component.exports